import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { ContainerType } from './containerType';

export class ContainerTypeInput extends ContainerType implements EntityInput<ContainerType> {
  forCreate(): CreateContainerTypeInput {
    return CreateContainerTypeInput.from(this, CreateContainerTypeInput);
  }

  forUpdate(): UpdateContainerTypeInput {
    return UpdateContainerTypeInput.from(this, UpdateContainerTypeInput);
  }

  forDelete(): DeleteContainerTypeInput {
    return DeleteContainerTypeInput.from(this, DeleteContainerTypeInput);
  }

  validate() {
    if (!this.name) return false;

    return true;
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }
}

export class CreateContainerTypeInput extends forCreate(ContainerType) {}

export class UpdateContainerTypeInput extends forUpdate(ContainerType) {}

export class DeleteContainerTypeInput extends forDelete(ContainerType) {}
